export const FETCH_CONTACT_DETAILS = "fetchContactDetails";
